<h1 mat-dialog-title>TFR {{tfr.notamId}}</h1>
<mat-dialog-content class="mat-typography">
  <div class="tfr-details__minor-header">Effective:</div>
  <p>{{ tfr.effectiveDate | date: 'MM/dd/yyyy HHmm' }} UTC - <span *ngIf="tfr.expirationDate; else noExpire">{{ tfr.expirationDate | date: 'MM/dd/yyyy HHmm' }} UTC</span></p>

  <div class="tfr-details__minor-header">Description:</div>
  <p style="margin-bottom: 2rem;" [innerText]="tfr.report"></p>
  <ng-template #noExpire>
    <span>Until Further Notice</span>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="mat-raised-button" (click)="cancel()">Close</button>
</mat-dialog-actions>
